<script lang="ts">
  export let headerText: string | null;
  export let useWhiteBackground: boolean = true;

  // If using the blue background, we need more spacing or else the blue container will look weird.
  const backgroundOuterClasses = useWhiteBackground ? "fizz-surface-white" : "fizz-surface-blue";
  const backgroundInnerClass = useWhiteBackground
    ? "fizz-inset-vertical-8"
    : "fizz-inset-stretch-24";
</script>

<div class="fizz-styles" data-testid="responsive-container-with-header">
  <div class={backgroundOuterClasses}>
    <div class="fizz-container {backgroundInnerClass}">
      {#if headerText}
        <h2 class="fizz-heading-3 fizz-text-center fizz-stack-24">{headerText}</h2>
      {/if}
      <div
        class="fizz-flex-multirow"
        style="--gap-small: 16px; --gap-large: 16px 48px; --max-width-small: 96px; --max-width-large: 140px"
      >
        <slot />
      </div>
    </div>
  </div>
</div>
